module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left-title"
  }, [_vm._v(_vm._s(_vm.heading))])]), _vm._v(" "), _c('div', {
    staticClass: "c-page-header__right"
  }, [_c('div', {
    staticClass: "c-rewards-navigation"
  }, [_c('button', {
    staticClass: "c-button qa-filter-modal-button",
    class: {
      't-button-secondary': _vm.filtersApplied, 't-button-transparent': !_vm.filtersApplied
    },
    on: {
      "click": _vm.toggleFilterModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_navigation.filters_button')) + " "), _c('i', {
    staticClass: "fa fa-sliders c-button__icon"
  })])])])]), _vm._v(" "), _c('rewards-filter-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilterModal),
      expression: "showFilterModal"
    }],
    on: {
      "close": _vm.toggleFilterModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25b8a6d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/RewardsNavigation.vue
// module id = 518
// module chunks = 1